import { styled, tabClasses, Tabs, tabsClasses, TabsProps } from "@mui/material";

interface ContainedTabsProps {
  showBackground?: boolean;
}

const ContainedTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "showBackground",
})<ContainedTabsProps>(({ theme, showBackground = true }) => {
  return {
    border: "none",
    [`.${tabsClasses.flexContainer}`]: {
      justifyContent: "center",
      gap: theme.spacing(0.5),
      [`.${tabClasses.root}`]: {
        borderRadius: theme.spacing(0.5),
        transition: "background-color 0.2s ease-in-out",
        padding: `${theme.spacing(1)} ${theme.spacing(1.25)}`,
        [`&.${tabClasses.selected}`]: {
          fontWeight: showBackground ? 500 : 600,
          background: showBackground ? "#F1F0FE" : "inherit",
        },
      },
    },
    [`.${tabsClasses.indicator}`]: {
      display: "none",
    },
  };
});

export default ContainedTabs;
